import {
    RefObject,
    useCallback,
    useEffect,
    useMemo,
    useRef,
    useState,
} from 'react';

import { useOnClickOutside } from 'hooks';

interface Output {
    isOpen: boolean;
    toggle: () => void;
    container: RefObject<HTMLDivElement>;
}

const useSettingsDropdown = (): Output => {
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const container = useRef<HTMLDivElement>(null);

    const toggle = useCallback(() => {
        setIsOpen(!isOpen);
    }, [isOpen]);

    const close = useCallback(() => setIsOpen(false), []);

    const handleKeydown = useCallback(
        (event: KeyboardEvent) => {
            if (event.keyCode === 27) close();
        },
        [close]
    );

    useEffect(() => {
        document.addEventListener('keydown', handleKeydown, false);

        return () => {
            document.removeEventListener('keydown', handleKeydown, false);
        };
    }, [handleKeydown]);

    const refs = useMemo(() => [container], []);

    useOnClickOutside({ refs, handler: close, isOpen });

    return {
        isOpen,
        toggle,
        container,
    };
};

export default useSettingsDropdown;
